export default "__VITE_ASSET__93e886be__"